<template>

	<div style="width: 100%;" id="box">
		<navbar></navbar>

		<br><br>
		<div class="content " style="width: 75%;margin: auto;">
			<!-- 头部 -->
			<el-row :gutter="20">
				<el-col class="header-col content-header-l" style="background-color:#343434;" :xs="24" :sm="24" :md="8"
					:lg="8" :xl="8">
					<div style="width: 100%;">
						<img src="../../../img/eth-01.png" height="70" style="float: left;margin-top: 25px" />
						<div class="content-header-l-l">

							<label>{{minerData.miner_name}} &nbsp;</label><br />
							<!-- <img src="../../../img/exchange.png" width="20"
							height="20" @click="exchangeMiner" style="margin-top: 5px;"><br /> -->
							<span>{{minerData.remark}}</span>
						</div>
						<!-- <img src="../../../img/miner-man.png" style="float: right;margin-top: 10px;" height="100" /> -->
						<div class="content-header-l-r">


						</div>

					</div>
				</el-col>



				<el-col class="header-col content-header-middle " :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
					<div class="content-header-r-main  ">

						<!-- 	<div id="" style="height: 100%; width: 80%; margin: auto; padding-top: 15px;  text-align: center;background-color: red;">
				
				<el-divider style="height: 70%"  direction="vertical"></el-divider>
				
				
			</div> -->

						<el-row :gutter="10">
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="earnings">

								<div style="">
									<center>
										<span style="">
											{{$t('labseth.lastdayearn')}}

											<el-tooltip class="item" effect="dark"
												:content="$t('labseth.lastdayearndisc')" placement="top">
												<i class="el-icon-question"></i>
											</el-tooltip>


										</span><br>
										<label>{{formatEthBalance(lastdayEarning)}}ETH</label>
									</center>
								</div>


							</el-col>
							<el-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" class="earnings">

								<div style="">
									<center>
										<span>
											{{$t('labseth.todayearn')}}
											<el-tooltip class="item" effect="dark"
												:content="$t('labseth.todayearndisc')" placement="top">
												<i class="el-icon-question"></i>
											</el-tooltip>
										</span><br>
										<label>{{formatEthBalance(todayearn)}}ETH</label>
									</center>
								</div>

							</el-col>
						</el-row>
					</div>
				</el-col>

				<el-col class="header-col content-header-r" :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
					<div class="content-header-r-main">

						<center>
							<div style="width: 80%">
								<span style="font-size: 18px;">
									{{$t('labseth.tobesubbalance')}}

								</span><br>

							</div>
							<!-- <label>{{formatEthBalance(minerData.eth_balance)}}ETH</label><el-badge type="warning" class="mark" value="昨日收益" /><br /> -->
							<label>{{formatEthBalance(minerData.eth_balance)}}ETH</label><br />
							<span>≈ {{fix2(formatEthBalance(minerData.eth_balance)*ethPrice.eth2usdt)}}
								USDT</span><br />
							<span>≈ {{fix2(formatEthBalance(minerData.eth_balance)*ethPrice.eth2cny)}} CNY</span><br />

							<!-- 	<el-button type="warning"  style="margin-top: -10px;" size="mini" @click="activeName_1='third'" round>
								{{$t('labseth.nowsubbalance')}}
							</el-button> -->
						</center>

					</div>
				</el-col>
			</el-row>
			<!-- 提醒公告 -->
			<br /><br />


			<div class="content-main" style="overflow-x: hidden;">


<el-row :gutter="20">
					<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
						<div class="grid-content">
							<el-card class="box-card hash-card" style="padding-bottom: 15px;">
								<div slot="header" class="clearfix">
									<span style="font-size: 18px;">{{$t('labseth.hashrate')}}</span>
									<!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
								</div>

								<ul style="margin-top: 0px;">
									<li class="card-li">
										<center>
											{{$t('anonminer.realhahs')}}
											<!-- <el-popover placement="top-start" width="200" trigger="hover"
												:content="$t('anonminer.realhahs_desc')">
												<i class="el-icon-warning-outline" style="color: #476EF6;"
													slot="reference"></i>
											</el-popover> -->
										</center>
									</li>
									<li class="card-li">
										<!-- <center>
											RAW
											<el-popover placement="top-start" width="200" trigger="hover" content="当前算法总算力">
												<i class="el-icon-warning-outline" style="color: #476EF6;" slot="reference"></i>
												
											</el-popover>
										</center> -->
										<center>
											{{$t('anonminer.avghash24')}}
											<el-popover placement="top-start" width="200" trigger="hover"
												:content="$t('anonminer.avghash24_desc')">
												<i class="el-icon-warning-outline" style="color: #476EF6;"
													slot="reference"></i>
												<!-- <el-button slot="reference" size="mini" icon="el-icon-search" circle></el-button> -->
											</el-popover>
										</center>
									</li>
								</ul>


								<ul >
									<li class="card-li">
										<center>
											<span style="font-size: 1.5rem; color: #000000;">{{realHashrate}}</span>
											<span style="color: rgb(153, 153, 153);font-size: 14px;">{{realHashrateUnit}}</span>
										</center>
									</li>
									<li class="card-li">
										<center>
											<span style="font-size: 1.5rem; color: #000000;" >{{averageHashrate}}</span>
											<span style="color: rgb(153, 153, 153);font-size: 14px;"
												>{{averageHashrateUnit}}</span>
										</center>
									</li>
								</ul>
								
								
								<ul style="margin-top: 0px;">
									<li class="card-li">
										<center>
											{{$t('labseth.localhash')}}
											<!-- <el-popover placement="top-start" width="200" trigger="hover"
												:content="$t('anonminer.realhahs_desc')">
												<i class="el-icon-warning-outline" style="color: #476EF6;"
													slot="reference"></i>
											</el-popover> -->
										</center>
									</li>
									<li class="card-li">
										<center>
											 &nbsp;
											<!-- {{$t('anonminer.avghash24')}} -->
											<!-- <el-popover placement="top-start" width="200" trigger="hover"
												:content="$t('anonminer.avghash24_desc')">
												<i class="el-icon-warning-outline" style="color: #476EF6;"
													slot="reference"></i>
											</el-popover> -->
										</center>
									</li>
								</ul>
								
								
								<ul >
									<li class="card-li">
										<center>
											<span style="font-size: 1.5rem; color: #000000;">{{total_hash}}</span>
											<span style="color: rgb(153, 153, 153);font-size: 14px;">{{total_hashUnit}}</span>
										</center>
									</li>
									
									<li class="card-li">
										<center>
											<span style="font-size: 1.5rem; color: #000000;" > &nbsp;</span>
											<span style="color: rgb(153, 153, 153);font-size: 14px;"
												> &nbsp;</span>
										</center>
									</li>
								</ul>
								
								
								
								
								<div style="margin-bottom: -10px;">
									 &nbsp;
								</div>
								
								
								
								
							


							</el-card>
						</div>
					</el-col>
					<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
						<div class="grid-content">
							<el-card class="box-card" style="padding-bottom: 15px;">
								<div slot="header" class="clearfix">
									<span style="font-size: 18px;">{{$t('labseth.totalshare')}}</span>
									<!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
								</div>
								<ul style="padding-bottom: 15px;" >
									<li class="card-li">
										<!-- <center> -->
											<div style="width: 70%; margin: auto;" id="hashcharts" class="echarts">
												<div id="share-charts" style="height: 150px;"></div>
											</div>
										<!-- </center> -->
									</li>
									<li class="card-li">
										<ul style="margin-top: 10%;">
											<li>
												<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#55ff00;"></span>
												<span style="font-size: 14px;">{{$t('labseth.Valid')}} <strong style="color: #000000;">{{percent_validShares}}%</strong>  {{formatterShare(total_validShares)}}  </span>
											</li>
											<li style="margin-top: 8px;">
												<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#fca800;"></span>
												<span style="font-size: 14px;">{{$t('labseth.Stale')}} <strong style="color: #000000;">{{percent_staleShares}}%</strong>     {{formatterShare(total_staleShares)}} </span>
											</li>
											<li style="margin-top: 8px;">
												<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:#ff0000;"></span>
												<span style="font-size: 14px;">{{$t('labseth.Invalid')}} <strong style="color: #000000;">{{percent_invalidShares}}%</strong>    {{formatterShare(total_invalidShares)}} </span>
											</li>
										</ul>

									</li>
								</ul>
								

							</el-card>
						</div>
					</el-col>
					
					<el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
						<div class="grid-content" >
							<el-card class="box-card" style="padding-bottom: 15px;">
								<div slot="header" class="clearfix">
									<span style="font-size: 18px;">{{$t('labseth.miners')}}</span>
									<!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
								</div>
								<ul style="margin-top: 30px;">
									<li class="card-li">
										
											<span style="font-size: 0.9rem; color: #000000;">{{$t('labseth.online')}}:{{total_online}}</span>
											<!-- <span style="color: rgb(153, 153, 153);font-size: 14px;">KH/s</span> -->
										
									</li>
									<li class="card-li" style="text-align: right;">
										
											<span style="font-size: 0.9rem; color: #000000;" >{{$t('anonminer.offline')}}:{{total_offline}}</span>
											<!-- <span style="color: rgb(153, 153, 153);font-size: 14px;"
												id="rawUnit">KH/s</span> -->
										
									</li>
								</ul>
								<ul>
									<li>
										<el-progress style="width: 100%;margin-top: 65px;" :percentage="minerpercentage" :show-text="false" :color="customColors"></el-progress>
									</li>
								</ul>
								<div style="margin-bottom: 38px;">
									 &nbsp;
								</div>
							</el-card>
						</div>
					</el-col>
				</el-row>
				<br>


				<el-tabs v-model="activeName_1" @tab-click="handleClick">
					<!-- <center><el-progress :percentage="refreshNum" status="success"></el-progress></center> -->
					<!-- <center><el-tag  type="danger" effect="dark" size="medium">{{60-refreshNum}}秒后刷新</el-tag></center> -->
					<!-- <center><span id="">
						{{60-refreshNum}}秒后刷新
					</span></center>
					<br> -->

					<el-tab-pane name="first" v-if="isShow1"><span slot="label">{{$t('labseth.miner')}}
							<el-badge class="mark" :value="total_online" />
						</span>
						<div
							style=" width: 100%; margin: 0px auto 0px auto; background-color: white;border-radius: 5px;">
							<el-tabs v-model="activeName_2" style="padding:15px ;">
								<!-- 在线矿机 -->
								<el-tab-pane name="online">
									<span slot="label"><i class="el-icon-success" style="color: #15e715"></i>
										{{$t('labseth.online')}}({{total_online}})</span>
									<div style="width: 100%;height: 20px;">
										<el-switch style="float: right;right: 0px;margin-bottom: 5px;" v-model="useList"
											@change="chooseuselist()" :active-value="true" :inactive-value="false"
											inactive-color="#ff0000" active-color="#4de700"
											:active-text="$t('labseth.openlist')"
											:inactive-text="$t('labseth.closelist')">
										</el-switch>
									</div>

									<el-table :empty-text="$t('labseth.empty')" v-loading="minerdataloading"
										:data="onlineList.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
										:default-sort="{ prop: 'minername', order: 'descending' }" border
										:key="Math.random()" style="width: 100%" :fit='true'>
										<el-table-column :label="$t('anonminer.id')" width="50" align="center"
											prop="id">
											<template slot-scope="scope">
												{{ scope.$index + 1 }}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.minername')" sortable
											align="center" prop="name"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.lts')" sortable
											align="center" prop="lts">
											<template slot-scope="scope">
												{{ dateformat(scope.row.lts/1000)}}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.realtimehash')" sortable
											align="center" prop="hash">
											<template slot-scope="scope">
												{{ formatter2(scope.row.hash)}}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.validshares')"
											sortable align="center" prop="validShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.invalidshares')"
											sortable align="center" prop="invalidShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.stale')" align="center"
											prop="staleShares"></el-table-column>
										<el-table-column :resizable="false" align="center">
											<template slot="header" slot-scope="scope">
												<el-input v-model="search" size="mini"
													:placeholder="$t('anonminer.input_search_miner')" />
											</template>
											<template slot-scope="scope">
												<span style="color: #00d000;">{{$t('labseth.online')}}</span>
											</template>
										</el-table-column>
									</el-table>
									<div class="paginationClass" style="width:70%;margin:auto;">
										<el-pagination style="float: right;margin-top: 15px;margin-bottom: 20px;"
											@size-change="onlineSizeChange1" @current-change="onlineCurrentChange1"
											:current-page="onlinecurrentPage" :page-sizes="[5, 10, 15, 20]"
											:page-size="onlinepageSize" layout="total, sizes, prev, pager, next, jumper"
											:total="total_online">
										</el-pagination>
									</div>
								</el-tab-pane>

								<!-- 离线矿机 -->
								<el-tab-pane>
									<span slot="label"><i class="el-icon-error" style="color: red;"></i>
										{{$t('anonminer.offline')}}({{total_offline}})</span>
									<el-table :empty-text="$t('labseth.empty')" v-loading="minerdataloading"
										:data="offlineminer.filter(data => !search || data.name.toLowerCase().includes(search.toLowerCase()))"
										:default-sort="{ prop: 'pay', order: 'descending' }" border :key="Math.random()"
										style="width: 100%" :fit='true'>
										<el-table-column :label="$t('anonminer.id')" width="50" align="center"
											prop="id">
											<template slot-scope="scope">
												{{ scope.$index + 1 }}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.minername')" sortable
											align="center" prop="name"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.lts')" sortable
											align="center" prop="lts">
											<template slot-scope="scope">
												{{ dateformat(scope.row.lts/1000)}}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.realtimehash')" sortable
											align="center" prop="hash">
											<template slot-scope="scope">
												{{ formatter2(scope.row.hash)}}
											</template>
										</el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.validshares')"
											sortable align="center" prop="validShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('anonminer.invalidshares')"
											sortable align="center" prop="invalidShares"></el-table-column>
										<el-table-column :resizable="false" :label="$t('labseth.stale')" align="center"
											prop="staleShares"></el-table-column>
										<el-table-column :resizable="false" align="center">
											<template slot="header" slot-scope="scope">
												<el-input v-model="search" size="mini"
													:placeholder="$t('anonminer.input_search_miner')" />
											</template>
											<template slot-scope="scope">
												<span style="color: red;">{{$t('anonminer.offline')}}</span>
											</template>
										</el-table-column>
									</el-table>
									<div class="paginationClass" style="width:70%;margin:auto;">
										<el-pagination style="float: right;margin-top: 15px;margin-bottom: 20px;"
											@size-change="offlineSizeChange1" @current-change="offlineCurrentChange1"
											:current-page="offlinecurrentPage" :page-sizes="[5, 10, 15, 20]"
											:page-size="offlinepageSize"
											layout="total, sizes, prev, pager, next, jumper" :total="total_offline">
										</el-pagination>
									</div>
								</el-tab-pane>

							</el-tabs>

						</div>


					</el-tab-pane>

					<el-tab-pane :label="$t('labseth.earning')" name="second" v-if="isShow2">
						<div class="content-earning">

							<el-collapse accordion v-model="earning">
								<el-collapse-item name="1">
									<template slot="title">
										<span class="earning-title">{{$t('labseth.minedisc')}}</span>
									</template>
									<el-row :gutter="10">
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center><label>{{$t('labseth.earnmodel')}}</label><br><span>PPS+</span>
												</center>
											</div>
										</el-col>
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center><label>{{$t('labseth.fee')}}</label><br><span>1.5%</span>
												</center>
											</div>

										</el-col>
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center><label>{{$t('labseth.intoaccount')}}</label>
													<el-tooltip class="item" effect="dark"
														:content="$t('labseth.intoaccountdisc')" placement="top-start">
														<i class="el-icon-question"></i>
													</el-tooltip>
													<br><span>T+1</span>
												</center>
											</div>

										</el-col>
										<el-col :xs="24" :sm="6" :md="6" :lg="6" :xl="6">
											<div class="earning-content">
												<center>
													<label>{{$t('labseth.support')}}</label><br><span>USDT/ETH/Alipay</span>
												</center>
											</div>
										</el-col>
									</el-row>
								</el-collapse-item>

							</el-collapse>
						</div>
						<div>
						</div>
<!-- 算力图 -->
						<div class="earning-card">
							<el-card class="box-card">
								<div slot="header" class="clearfix">
									<span>{{$t('labseth.hashcharts')}}</span>

								</div>
								<div style="width: 100%;" id="hashcharts" class="echarts">
									<div id="hashrate-realtime" style="height: 290px;"></div>
								</div>
							</el-card>
						</div>



						<!-- 时时收益 -->
						<div class="earning-card">
							<el-card class="box-card">
								<div slot="header" class="clearfix">
									<span>{{$t('labseth.realearn')}}</span>

								</div>
								<div style="width: 100%;" id="hashcharts" class="echarts">
									<div id="earning-realtime"></div>
								</div>
							</el-card>
						</div>

						<!-- 时时收益 -->
						<!-- <div class="earning-card">
							<el-card class="box-card">
								<div slot="header" class="clearfix">
									<span>{{$t('labseth.hashcharts')}}</span>

								</div>
								<div style="width: 100%;" id="fcharts" class="echarts">
									<div id="earning-realtime"></div>
								</div>
							</el-card>
						</div> -->


					</el-tab-pane>


				</el-tabs>
			</div>
		</div>
		<!-- <footerbar></footerbar> -->
	</div>

</template>

<script>
	var axios = require('axios');
	var qs = require('qs');
	import * as echarts from 'echarts';
	import VueQr from 'vue-qr';
	import Clipboard from 'clipboard';
	import navbar from '../../../toolbar/navbar2.vue'
	// import footerbar from '../../../toolbar/footer.vue'
	export default {
		components: {
			VueQr,
			navbar
		},
		data() {
			var valiopt2 = (rule, value, callback) => {
				let reg = /^[0-9]+$/
				if (value === '') {
					callback(new Error($t('labseth.input')));
				} else if (!reg.test(value)) {
					callback(new Error($t('labseth.codeerr')));
				} else {
					callback();
				}
			};
			var valiopteth = (rule, value, callback) => {
				let reg = /^(0x)?[0-9a-fA-F]{40}$/
				if (value === '') {
					callback(new Error($t('labseth.inputeth')));
				} else if (!reg.test(value)) {
					callback(new Error($t('labseth.addresserr')));
				} else {
					callback();
				}
			};
			var key8 = (rule, value, callback) => {
				// value=this.a.email
				const mailReg = /^[A-Za-z0-9]+$/


				setTimeout(() => {
					if (mailReg.test(value)) {
						callback()
					} else {
						callback(new Error($t('labseth.alipaykeyerr')))
					}
				}, 100)
			}
			return {

				url: this.$global.url, //"https://api.starmap.stream"
				minerid: 2,
				ETH_MULTIPLIER: 1000000000000000000,
				minerdataloading: true,
				token: "",
				userStatus: -2,
				allminer: [],
				onlineminer: [],
				offlineminer: [],
				total_offline: 0,
				total_online: 0,
				activeName_1: "second",
				activeName_2: "online",
				offlineloading: true,
				search: '',
				earning: "1",
				option: {},
				myChart: null,
				hashChart: null,
				paymentOrderList: [],
				isShow1: true,
				isShow2: true,
				isShow3: true,
				isShow4: true,
				isShow5: true,
				addPaymentOrderForm: {
					minerId: this.minerid,
					payType: '',
					usdt: 0.00,
					paymentAccount: '',
					money: 0.0,
					name: '',
					money2: 0.0,
					usdt2: 0.0,
					eth: 0.0
				},
				addpaymentaccountDialog: false,
				addpaymentaccountDialogWidth: "100%",
				addPaymentAccountForm: {
					minerid: this.minerid,
					type: '',
					account: '',
					name: '',
				},
				addPaymentAccountrules: {},
				addPaymentOrderrules: {},
				optshow: false,
				logoSrc: "",
				optSrc: "",
				optkey: "",
				google: {
					opt: ''
				},
				echangeMiner: false,
				minerList: [],
				minerData: {
					"id": 0,
					"user_id": 0,
					"miner_name": "",
					"eth_balance": "0",
					"etc_balance": "0.0000",
					"frozen_capital": "0",
					"remark": null
				},
				addminerdialog: false,
				mineraccount: {
					minerName: '',
					remark: ''
				},
				ethPrice: {
					"eth2cny": 0,
					"eth2usdt": 0,
					"usdt2cny": 0
				},
				paymentaccountList: [],
				paymentAccount: {
					usdt: [],
					eth: [],
					zfb: []
				},
				AccountList: [],
				optRes: false,
				optrules: {
					opt: [{
						validator: valiopt2,
						trigger: 'blur'
					}]
				},
				usdtrules: {
					wallet: [{
						validator: valiopteth,
						trigger: 'blur'
					}],
					account: [{
						validator: key8,
						trigger: 'blur'
					}]
				},
				refreshNum: 0,
				onlinepageSize: 10,
				offlinepageSize: 10,
				onlinecurrentPage: 1,
				offlinecurrentPage: 1,
				onlineList: [],
				offlineList: [],
				alipayCNY: " ≈ 0 CNY",
				subusdt: " ≈ 0 USDT",
				fullscreenLoading: false,
				useList: true,
				lastdayEarning: 0,
				todayearn: 0,
				minername: "st_jiahe",
				
				sharecharts: null,
				customColors: [
				          {color: '#ff0000', percentage: 20},
				          {color: '#ffaa00', percentage: 40},
				          {color: '#ffaa00', percentage: 60},
				          {color: '#5cb87a', percentage: 80},
				          {color: '#5cb87a', percentage: 100}
				        ],
				minerpercentage:100,
				showtext:false,
				percent_validShares:0,
				percent_staleShares:0,
				percent_invalidShares:0,
				total_validShares:0,
				total_staleShares:0,
				total_invalidShares:0,
				averageHashrate:"",
				averageHashrateUnit:"",
				realHashrateUnit:"",
				realHashrate:"",
				
				total_hash:0,
				total_hashUnit:""
			}
		},
		watch: {
			'addPaymentOrderForm.payType': {
				handler(newName, oldName) {
					if (newName === "1") { //cny
						// this.addPaymentOrderForm.money2=this.fix2(this.ethPrice.eth2cny*this.formatEthBalance(this.minerData.eth_balance))
						this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.eth_balance)
						this.AccountList = this.paymentAccount.zfb
					} else if (newName === "2") { //eth
						this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.eth_balance)
						this.AccountList = this.paymentAccount.eth
					} else if (newName === "0") { //usdt
						// this.addPaymentOrderForm.usdt2=this.fix2(this.ethPrice.eth2usdt*this.formatEthBalance(this.minerData.eth_balance))
						this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.eth_balance)
						this.AccountList = this.paymentAccount.usdt
					}
				}
			},

		},
		filters: {
			formatDate: function(value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
			}
		},
		created() {
			let that=this
			this.token = localStorage.getItem("token")
			let miner = this.$urlParse.getUrlKey('miner');
			this.minername = miner
			this.initMinerData()
			this.option = {
				color: [
					'#55ff00',
					'#c0e7ff',
					'#adebb7',
					'#2f4554',
					'#61a0a8',
					'#91c7ae',
					'#749f83',
					'#bda29a',
					'#6e7074',
					'#546570',
					'#c4ccd3'
				],
				xAxis: {
					type: 'category',
					data: []
				},
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						}
					}
				},
				dataZoom: [{
						// startValue: '2014-06-01'
					},
					{
						type: 'inside'
					}
				],
				yAxis: {
					type: 'value'
				},
				series: [{
					data: [],
					type: 'bar'
				}]
			};
			this.addPaymentOrderrules = {
				payType: [{
					required: true,
					message: '请选择提现类型',
					trigger: 'change'
				}],
				paymentAccount: [{
					required: true,
					message: '请输入提现账户',
					trigger: 'change'
				}],
				money: [{
					required: true,
					message: '请输入提现账户',
					trigger: 'change'
				}]
			}
			this.hashChartOption = {
				xAxis: {
					type: 'category',
					data: []
				},
				legend: {
					data: ['实时', '平均']
				},
				yAxis: {
					type: 'value',
					axisLabel: {
						formatter: function(value) {
							if (value >= 1 && value < 1000) {
								// texts.push(value + 'H/s')
								return value.toFixed(2) + 'H/s'
							} else if (value >= 1000 && value < 1000000) {
								return (value / 1000).toFixed(2) + 'KH/s'
							} else if (value >= 1000000 && value < 1000000000) {
								return (value / 1000000).toFixed(2) + 'MH/s'
							} else if (value >= 1000000000 && value < 1000000000000) {
								return (value / 1000000000).toFixed(2) + 'GH/s'
							} else if (value >= 1000000000000) {
								return (value / 1000000000000).toFixed(2) + 'TH/s'
							} else if (value == 0) {
								return (0)
							}
						}
					}
				},
				dataZoom: [{
						// startValue: '2014-06-01'
					},
					{
						type: 'inside'
					}
				],
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'cross',
						label: {
							backgroundColor: '#6a7985'
						},
					},
					// formatter: '{b0}<br />{a0}:{c0}<br />{a1}:{c1}%',
					formatter: function(params) {
						return params[0].name + '<br/>' +
							'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
							params[0].color + ';"></span>' +
							params[0].seriesName + ' : ' + that.formatterHash(params[0].value) + '<br/>' +
							'<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:' +
							params[1].color + ';"></span>' +
							params[1].seriesName + ' : ' + that.formatterHash(params[1].value);
			
					}
				},
				series: [{
						name: "实时",
						data: [],
						type: 'line',
						smooth: true
					},
					{
						name: "平均",
						data: [],
						type: 'line',
						smooth: true
					}
				]
			};
			this.sharechartsOption = {
				color:["#4ce600","#fca800","#ff0000"],
				tooltip: {
					trigger: 'item',
					position: function(point, params, dom, rect, size){
					         //  size为当前窗口大小
					         if((size.viewSize[0]/2)>=point[0]){
					             //其中point为当前鼠标的位置
					             return [point[0]+50,'10%'];
					         }else{
					             //其中point为当前鼠标的位置
					             return [point[0]+50,'10%'];
					         }
					        }
				},
				series: [{
					name: '提交份额',
					type: 'pie',
					radius: ['100%', '70%'],
					avoidLabelOverlap: false,
					itemStyle: {
						borderRadius: 5,
						borderColor: '#fff',
						borderWidth: 2
					},
					label: {
						show: false,
						position: 'center'
					},
					emphasis: {
						label: {
							show: false,
							fontSize: '40',
							fontWeight: 'bold'
						}
					},
					labelLine: {
						show: false
					},
					data: [
						{
							itemStyle: "#55ff00",
							value: 1000,
							name: '有效份额'
						},
						{
							itemStyle: "#fca800",
							value: 200,
							name: '延迟份额'
						},
						{
							itemStyle: "#ff0000",
							value: 100,
							name: '无效份额'
						},
					]
				}]
			};
		},
		async mounted() {
			let that = this

			await this.initMiner()
			await this.initlastdayearn()
			await this.checkUserStatus()
			await this.getEthPrice()
			await this.initPaymentHistoryCharts()
			await this.gethashrate()
			this.initHashrateCharts()
			await this.initsharedata()
			this.addPaymentOrderForm.usdt2 = this.formatEthBalance(this.minerData.eth_balance)
			this.addPaymentOrderForm.minerId = this.minerid
			this.addPaymentAccountForm.minerid = this.minerid
			// var fwidth=document.getElementById('fcharts').offsetWidth+'px'
			// document.getElementById('earning-realtime').style.width=fwidth

			// window.addEventListener("resize", this.chartResize);
			//window.addEventListener('touchmove', handler, { passive: false})；
			let width1 = document.body.clientWidth
			if (width1 < 768) {
				that.addpaymentaccountDialogWidth = "80%"
			} else if (width1 >= 768 && width1 <= 1200) {
				that.addpaymentaccountDialogWidth = "50%"
			} else {
				that.addpaymentaccountDialogWidth = "30%"
			}
			window.onresize = function() {
				that.myChart.resize();
				that.hashChart.resize();
				let width1 = document.body.clientWidth
				if (width1 < 768) {
					that.addpaymentaccountDialogWidth = "80%"
				} else if (width1 >= 768 && width1 <= 1200) {
					that.addpaymentaccountDialogWidth = "50%"
				} else {
					that.addpaymentaccountDialogWidth = "30%"
				}
			}
			window.setInterval(function() {

				that.refreshNum = that.refreshNum + 1
				if (that.refreshNum >= 60) {
					that.onlineminer = []
					that.offlineminer = []
					that.total_hash=0
					that.initMiner()
					that.initHashrateCharts()
					that.gethashrate()
					that.initsharedata()
					that.refreshNum = 0
				}
			}, 1000)
			window.setInterval(function() {
				that.initMinerData()
			}, 1000 * 60 * 10)
		},

		methods: {
			gethashrate(){
				
				var config = {
				  method: 'get',
				  url: this.url+'/v1/getHashate?minername='+this.minerData.miner_name,
				  headers: { }
				};
				let that=this
				axios(config)
				.then(function (response) {
					var tmp1=response.data.data.currentHashrate
					var tmp2=response.data.data.averageHashrate
					tmp1=that.formatter(tmp1).split("|")
					tmp2=that.formatter(tmp2).split("|")
					that.realHashrate=tmp1[0]
					that.realHashrateUnit=tmp1[1]
					that.averageHashrate=tmp2[0]
					that.averageHashrateUnit=tmp2[1]
				  // console.log(JSON.stringify(response.data));
				})
				.catch(function (error) {
				  console.log(error);
				});

			},
			formatterShare(value){
				if(value>1000&&value<1000000){
					return (value/1000).toFixed(2)+"K"
				}else if(value>1000000&&value<1000000000){
					return (value/1000000).toFixed(2)+"W"
				}else if(value>1000000000&&value<1000000000000){
					return (value/1000000000).toFixed(2)+"W"
				}else{
					return value
				}
			},
			initsharedata(){
				let that=this
				var config = {
				  method: 'get',
				  url: this.url+'/v1/getminershares?minername='+this.minerData.miner_name,
				  headers: { 
				    'token': this.token
				  }
				};
				
				axios(config)
				.then(function (response) {
					var totalshare=response.data.data.validShares+response.data.data.invalidShares
					
					that.percent_validShares = (response.data.data.validShares/totalshare*100).toFixed(2)
					that.percent_invalidShares = (response.data.data.invalidShares/totalshare*100).toFixed(2)
					that.percent_staleShares = (response.data.data.staleShares/totalshare*100).toFixed(2)
					
					
					that.sharechartsOption.series[0].data[0].value=response.data.data.validShares
					that.sharechartsOption.series[0].data[1].value=response.data.data.staleShares
					that.sharechartsOption.series[0].data[2].value=response.data.data.invalidShares
					that.total_validShares=response.data.data.validShares
					that.total_staleShares=response.data.data.staleShares
					that.total_invalidShares=response.data.data.invalidShares
					var chartDom = document.getElementById('share-charts');
					that.sharecharts = echarts.init(chartDom);
					that.sharechartsOption && that.sharecharts.setOption(that.sharechartsOption);
				  // console.log(JSON.stringify(response.data));
				})
				.catch(function (error) {
				  console.log(error);
				});
			
			},
			formatterHash(value) {
				if (value >= 1 && value < 1000) {
					// texts.push(value + 'H/s')
					return value.toFixed(2) + 'H/s'
				} else if (value >= 1000 && value < 1000000) {
					return (value / 1000).toFixed(2) + 'KH/s'
				} else if (value >= 1000000 && value < 1000000000) {
					return (value / 1000000).toFixed(2) + 'MH/s'
				} else if (value >= 1000000000 && value < 1000000000000) {
					return (value / 1000000000).toFixed(2) + 'GH/s'
				} else if (value >= 1000000000000) {
					return (value / 1000000000000).toFixed(2) + 'TH/s'
				} else if (value == 0) {
					return (0)
				}
			},
			initlastdayearn() {
				var config = {
					method: 'get',
					url: this.url + '/v1/getLastDayEarnings?minername=' + this.minername,

				};
				let that = this
				axios(config)
					.then(function(response) {
						that.lastdayEarning = response.data.data.lastDayEarnings
						that.todayearn = response.data.data.toDayEarnings
					})
					.catch(function(error) {
						console.log(error);
					});

			},



			chooseuselist() {
				if (!this.useList) {
					// console.log(this.total_online)
					this.onlineSizeChange1(this.total_online)
				} else {
					this.onlineSizeChange1(10)
				}
			},

			calcPaymentOrderRes(value) {
				value = value / this.ETH_MULTIPLIER
				return Math.floor(value * 100000000) / 100000000
			},


			deleteMineraccount(miner) {

			},
			onlineSizeChange1: function(pageSize) {
				// 每页条数切换
				this.onlinepageSize = pageSize;
				this.onlineCurrentChange1(this.onlinecurrentPage);
			},
			onlineCurrentChange1: function(currentPage) {
				//页码切换
				this.onlinecurrentPage = currentPage;
				this.onlinecurrentChangePage(this.onlineminer, currentPage);
			},
			//分页方法（重点）
			onlinecurrentChangePage(list, currentPage) {
				let from = (currentPage - 1) * this.onlinepageSize;
				let to = currentPage * this.onlinepageSize;
				this.onlineList = [];
				for (; from < to; from++) {
					if (list[from]) {
						this.onlineList.push(list[from]);
					}
				}
			},

			offlineSizeChange1: function(pageSize) {
				// 每页条数切换
				this.onlinepageSize = pageSize;
				this.onlineCurrentChange1(this.onlinecurrentPage);
			},
			offlineCurrentChange1: function(currentPage) {
				//页码切换
				this.offlinecurrentPage = currentPage;
				this.offlinecurrentChangePage(this.offlineminer, currentPage);
			},
			//分页方法（重点）
			offlinecurrentChangePage(list, currentPage) {
				let from = (currentPage - 1) * this.offlinepageSize;
				let to = currentPage * this.offlinepageSize;
				this.offlineList = [];
				for (; from < to; from++) {
					if (list[from]) {
						this.offlineList.push(list[from]);
					}
				}
			},
			async initPaymentHistoryCharts() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/v1/getPaymentHistory?minername=' + this.minername,

				};

				await axios(config)
					.then(function(response) {
						for (var item in response.data.data) {
							that.option.xAxis.data.unshift(that.dataformater2(response.data.data[item].time))
							that.option.series[0].data.unshift(Math.floor((response.data.data[item].amount / that
								.ETH_MULTIPLIER) * 10000000) / 10000000)
						}
						var chartDom = document.getElementById('earning-realtime');
						that.myChart = echarts.init(chartDom, {
							renderer: 'svg'
						});
						that.option && that.myChart.setOption(that.option);
					})
					.catch(function(error) {
						console.log(error);
					});
			},
		async initHashrateCharts() {
			let that = this
			// var chartDom = document.getElementById('hashrate-realtime');
			// that.hashChart = echarts.init(chartDom, {
			// 	renderer: 'svg'
			// });
			// that.hashChartOption && that.hashChart.setOption(that.hashChartOption);
			var config = {
				method: 'get',
				url: this.url+'/v1/gethistoryhashrate?minername='+this.minerData.miner_name,
				headers: {
					'token': this.token
				}
			};
		
			await axios(config)
				.then(function(response) {
					that.hashChartOption.series[0].data=[]
					that.hashChartOption.series[1].data=[]
					that.hashChartOption.xAxis.data=[]
					for (var item in response.data.data) {
						that.hashChartOption.xAxis.data.push(that.dataformater2(response.data.data[item].time *
							1000))
						that.hashChartOption.series[0].data.push(parseFloat(response.data.data[item]
							.currentHashrate))
						that.hashChartOption.series[1].data.push(parseFloat(response.data.data[item]
							.averageHashrate))
					}
					// if(response.data.data.length===0){
					// 	that.averageHashrate=0.00
					// 	that.averageHashrateUnit="H/s"
					// }else{
					// 	var temp=response.data.data[response.data.data.length-1].averageHashrate
					// 	temp=that.formatter(temp).split("|")
						
					// 	that.averageHashrate=temp[0]
					// 	that.averageHashrateUnit=temp[1]
						
					// 	var temp2=response.data.data[response.data.data.length-1].currentHashrate
					// 	temp2=that.formatter(temp2).split("|")
						
					// 	that.realHashrate=temp2[0]
					// 	that.realHashrateUnit=temp2[1]
					// }
					
					
					// console.log(that.hashChartOption)
					var chartDom = document.getElementById('hashrate-realtime');
					that.hashChart = echarts.init(chartDom, {
						renderer: 'svg'
					});
					that.hashChartOption && that.hashChart.setOption(that.hashChartOption);
				})
				.catch(function(error) {
					console.log(error);
				});
		
		},
		

		formatter(value) {
		
			value = value * 1
			// console.log(value)
			if (value > 0 && value < 1000) {
		
				return value.toFixed(2) + '| H/s'
		
				//.toFixed(2) + '| H/s';
			} else if (value >= 1000 && value < 1000000) {
				return (value / 1000).toFixed(2) + '| KH/s';
			} else if (value >= 1000000 && value < 1000000000) {
				return (value / 1000000).toFixed(2) + '| MH/s';
			} else if (value >= 1000000000 && value < 1000000000000) {
				return (value / 1000000000).toFixed(2) + '| GH/s';
			} else if (value >= 1000000000000) {
				return (value / 1000000000000).toFixed(2) + '| TH/s';
			} else if (value == 0) {
				return 0 + '| H/s';
			}
		},
			allTixian() {
				if (this.addPaymentOrderForm.payType === "1") {
					// this.addPaymentOrderForm.money=this.addPaymentOrderForm.money2
					this.addPaymentOrderForm.usdt = this.addPaymentOrderForm.usdt2
				} else {
					this.addPaymentOrderForm.usdt = this.addPaymentOrderForm.usdt2
				}
				this.changeCNY()
			},
			fix2(num) {
				return Math.floor(num * 100) / 100
			},
			getEthPrice() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/v1/getPrice',

				};

				axios(config)
					.then(function(response) {
						that.ethPrice = response.data.data
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			formatEthBalance(eth) {
				let tmp = eth / this.ETH_MULTIPLIER
				let temp2 = Math.floor(tmp * 100000000) / 100000000
				return temp2
			},

			async initMinerData() {
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/v1/getMinerDataByMinerName?minername=' + this.minername,

				};
				// console.log("init")
				await axios(config)
					.then(function(response) {
						// console.log(response.data.code)
						if (response.data.code === 30001) {
							that.$message.error(that.$t('observer.wktobserver'))
							that.$router.push("/")
						} else {
							that.minerData = response.data.data
							that.minerid = response.data.data.id
						}

						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error)
						that.$message.error(that.$t('labseth.unknown'))
						that.$router.push("/")
					});

			},

			checkUserStatus() { //检查用户状态
				let that = this
				var config = {
					method: 'post',
					url: this.url + '/api/user/status',
					headers: {
						'token': this.token
					}
				};

				axios(config)
					.then(function(response) {
						that.userStatus = response.data.data
						if (response.data.data === -2) {
							that.getOPT()
						}
						// console.log(JSON.stringify(response.data));
					})
					.catch(function(error) {
						console.log(error);
					});
				// console.log(this.userStatus)
			},


			copykey(ele) {
				let that = this
				var clipboard = new Clipboard('.copyButton')
				clipboard.on('success', e => {
					this.$notify({
						title: that.$t('labseth.copysuccess'),
						message: that.$t('labseth.copytip'),
						type: 'success'
					});
					// 释放内存
					clipboard.destroy();
				})
				clipboard.on('error', e => {
					// 不支持复制
					// 释放内存
					clipboard.destroy()
				})
				// console.log("copy")
			},


			async handleClick(tab) {
				if (tab.name === "third") {
					await this.initPaymentAccount()
					// console.log("third")
				} else if (tab.name === "first") {
					this.onlineCurrentChange1(1)
					// console.log("first")
				} else if (tab.name === "fifth") {
					await this.initPaymentAccount()
					// console.log(this.paymentAccount['data'])
					// console.log("first")
				} else {
					// console.log("second")
				}
			},

			chartResize() {
				let eleArr = [this.myChart];
				for (let i = 0; i < eleArr.length; i++) {
					//此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
					setTimeout(function() {
						eleArr[i].resize();
					}, 200);
				}
			},

			dateformat(ts) {
				var time = new Date().getTime() / 1000 - ts;
				if (time < 60 && time > 0) {
					time = time.toFixed(0) + this.$t('anonminer.secago');
				} else if (time >= 60 && time < 3600) {
					time = Math.floor(time / 60) + this.$t('anonminer.minago');
				} else if (time >= 3600 && time < 3600 * 24) {
					time = Math.floor(time / 3600) + this.$t('anonminer.hourago');
				} else if (time >= 3600 * 24 && time < 3600 * 24 * 30) {
					time = Math.floor(time / 3600 / 24) + this.$t('anonminer.dayago');
				} else if (time >= 3600 * 24 * 30) {
					time = Math.floor(time / 3600 / 24 / 30) + this.$t('anonminer.monago');
				} else {
					time = this.$t('anonminer.onesecago');
				}
				return time;
			},
			formatter2: function(value) {
				value = value * 1.0
				if (value >= 1 && value < 1000) {
					return value.toFixed(2) + 'H/s';
				} else if (value >= 1000 && value < 1000000) {
					return (value / 1000).toFixed(2) + 'KH/s';
				} else if (value >= 1000000 && value < 1000000000) {
					return (value / 1000000).toFixed(2) + 'MH/s';
				} else if (value >= 1000000000 && value < 1000000000000) {
					return (value / 1000000000).toFixed(2) + 'GH/s';
				} else if (value >= 1000000000000) {
					return (value / 1000000000000).toFixed(2) + 'TH/s';
				} else if (value > 0 && value < 1) {
					return value.toFixed(6) + 'H/s';
				} else if (value == 0) {
					return 0;
				}
			},
			dataformater2(value) {
				let date = new Date(value);
				let y = date.getFullYear();
				let MM = date.getMonth() + 1;
				MM = MM < 10 ? ('0' + MM) : MM;
				let d = date.getDate();
				d = d < 10 ? ('0' + d) : d;
				let h = date.getHours();
				h = h < 10 ? ('0' + h) : h;
				let m = date.getMinutes();
				m = m < 10 ? ('0' + m) : m;
				let s = date.getSeconds();
				s = s < 10 ? ('0' + s) : s;
				// return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
				return h + ':' + m;
			},


			async initMiner() { //加载矿工矿机数据
				let that = this
				var config = {
					method: 'get',
					url: this.url + '/v1/getMinersByMinerName?minername=' + this.minername,

					data: {}
				};
				let timeNow = new Date()
				// console.log("timeNow:" + timeNow.getTime())
				await axios(config).then(function(response) {

						for (var item in response.data.data.miner) {
							if (timeNow - response.data.data.miner[item].lts > 1000 * 60 * 15) {
								that.offlineminer.unshift(response.data.data.miner[item])
							} else {
								that.onlineminer.unshift(response.data.data.miner[item])
								// console.log(response.data.data.miner[item].hash)
								that.total_hash=that.total_hash+response.data.data.miner[item].hash
							}
						}
						var temp = that.formatter(that.total_hash).split("|")
						// console.log(temp)
						that.total_hash=temp[0]
						that.total_hashUnit=temp[1]
						
						
						that.total_offline = that.offlineminer.length
						that.total_online = that.onlineminer.length
						that.minerdataloading = false
						that.offlineloading = false
					})
					.catch(function(error) {
						console.log(error);
					});
				// console.log(this.allminer)
			}
		}

	}
</script>

<style>
	body {
		background-color: #F7FAFC;


	}

	* {
		/* overflow-x: hidden; */
		/* overflow: auto */
		 /* overflow-y: hidden; */
		/*-webkit-overflow-scrolling: touch; */

	}
	.card-li {
		float: left;
		width: 50%;
		color: rgb(153, 153, 153);
		font-size: 16px;
	}

	.hash-card {
		/* padding: 10px 20px; */
	}

	.el-card__header {
		padding: 10px 20px;
		border-bottom: 1px solid #EBEEF5;
		box-sizing: border-box;
	}
	.quick-start {
		background-color: white;
		width: 100%;
		border-radius: 5px;
	}
	.el-tab-pane{
		overflow-x: hidden;
	}
	/* **********************手机******************************** */
	@media screen and (max-width: 768px) {
		.content-header-l-l {
			color: white;
			float: left;
			margin-left: 5px;
			margin-top: 30px;
			font-size: 18px;
		}

		.content-header-l-l span {
			font-size: 10px;
			color: #bdbdbd;
			margin-top: 10px;
		}

		.content-header-l-r {
			color: white;
			float: right;
			margin-right: 5px;
			margin-top: 30px;
			font-size: 18px;
		}

		.content-header-l-r span {
			font-size: 10px;
			color: #bdbdbd;
			margin-top: 20px;
		}

		.content-header-r {
			background-color: #FFFFFF;
			height: 120px;
			border-radius: 5px;
		}

		.content-header-r-main label {
			font-size: 20px;
		}

		.content-header-r-main span {
			font-size: 16px;
		}

		.earning-title {
			margin-left: 10px;
			font-size: 24px;
		}

		.earning-content {
			margin-top: 15px;
		}

		.earning-content label {
			font-size: 14px;
		}

		.earning-content span {
			font-size: 18px;
		}

		.box-card {
			border-radius: 5px;
			margin-top: 15px;
		}

		#earning-realtime {
			width: 100%;
			height: 220px;
		}

		.withdrawal-content-card-2 {
			margin-top: 15px;
		}

		.el-message-box {
			width: 300px;
		}

		.content-header-middle {
			height: 180px;
			background-color: #ffffff;
			border-radius: 5px;
		}

		.earnings {
			margin-top: 30px;
		}

		.content {
			width: 100%;
			margin: auto;
		}


	}

	/* ****************************************************** */


	/* *********************笔记本********************************* */
	@media screen and (min-width: 768px) and (max-width: 1200px) {
		.content-header-l-l {
			color: white;
			float: left;
			margin-left: 5px;
			margin-top: 20px;
			font-size: 20px;
		}

		.content-header-l-l span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 10px;
		}

		.content-header-l-r {
			color: white;
			float: right;
			margin-right: 15px;
			margin-top: 20px;
			font-size: 20px;

		}

		.content-header-l-r span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 20px;
		}

		.content-header-r {
			/* margin-left: 20px; */
			background-color: #FFFFFF;
			height: 120px;
			border-radius: 5px;
		}

		.content-header-r-main label {
			/* color: #bdbdbd; */
			font-size: 20px;
		}

		.content-header-r-main span {

			font-size: 16px;
		}

		.content-earning {
			border-radius: 5px;
		}

		.earning-content {
			margin-top: 15px;
		}

		.earning-title {
			margin-left: 15px;
			font-size: 24px;
		}

		.earning-content label {
			font-size: 14px;
		}

		.earning-content span {
			font-size: 20px;
		}

		.box-card {
			border-radius: 5px;
			margin-top: 15px;
		}

		#earning-realtime {
			width: 100%;
			height: 300px;
		}

		.content-header-middle {
			height: 180px;
			background-color: #ffffff;
			border-radius: 5px;
		}

		.earnings {
			margin-top: 30px;
		}

		.content {
			width: 90%;
			margin: auto;
		}

	}

	/* ****************************************************** */

	/* *********************台式机********************************* */
	@media screen and (min-width: 1200px) {
		.content-header-l-l {
			color: white;
			float: left;
			margin-left: 5px;
			margin-top: 20px;
			font-size: 26px;
		}

		.content-header-l-l span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 10px;
		}

		.content-header-l-r {
			color: white;
			float: right;
			margin-right: 15px;
			margin-top: 20px;
			font-size: 24px;
		}

		.content-header-l-r span {
			font-size: 14px;
			color: #bdbdbd;
			margin-top: 20px;
		}

		.content-header-r {
			/* margin-left: 20px; */
			/* background-color: #FFFFFF; */
			height: 120px;
			border-radius: 5px;
		}

		.content-header-r-main label {
			font-size: 24px;
		}

		.content-header-r-main span {
			font-size: 16px;
		}

		.earning-content {
			margin-top: 15px;
		}

		.earning-title {
			margin-left: 15px;
			font-size: 24px;
		}

		.earning-content label {
			font-size: 14px;
		}

		.earning-content span {
			font-size: 22px;
		}

		.box-card {
			border-radius: 5px;
			margin-top: 15px;
		}

		#earning-realtime {
			width: 100%;
			height: 420px;
		}

		.earnings {

			margin-top: 30px;
		}


	}




	/* *********************适配三格窗********************************* */
	@media screen and (min-width: 992px) and (max-width: 1520px) {

		.content-header-middle {

			height: 120px;
			font-size: 16px;
			background-color: #ffffff;
			border-radius: 5px;
		}

		.content-header-r-main label {
			font-size: 16px;
		}

		.earnings {
			margin-top: 10px;
		}
	}

	/* *********************适配三格窗********************************* */
	@media screen and (min-width: 1200px) and (max-width: 1520px) {
		.earnings {
			margin-top: 35px;
		}

		.content-header-l label {
			font-size: 22px;
		}

	}

	/* ****************************************************** */
	.content {
		width: 90%;
		margin: 0 auto;
		border-radius: 0.3125rem;

	}

	.el-dialog {
		overflow: auto;
	}

	.my-account h2 {
		font-size: 24px;
		margin-bottom: 24px;
		font-weight: 300;
		color: var(--heading-color);
	}

	.content-header-l {
		background-color: #FFFFFF;
		height: 120px;
		border-radius: 5px;
	}

	.content-header-r-main {
		background-color: #FFFFFF;
		height: 120px;
		border-radius: 5px;
	}


	.header-col {
		margin-top: 10px;
	}

	.content-main {
		width: 100%;
	}
</style>
